"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElementsTree = void 0;
var native_pseudo_elements_set_1 = require("./utils/native-pseudo-elements-set");
/**
 * This function create a tree structure of internal parts starting form a variant customization
 * going over the inheritance of each internal part and also checking native pseudo elements usage.
 * @deprecated this will be removed when switching to config 2.0
 */
function createElementsTree(meta, simpleSelector, resolver) {
    var _a;
    // Assume simple customization selector like .myComponent or Component.
    // Ideally we want to use StylableSymbols here but historically we use a selector
    var elementsTree = (_a = {}, _a[simpleSelector] = {}, _a);
    var isClass = simpleSelector.startsWith('.');
    // finds the symbol name
    var name = isClass ? simpleSelector.slice(1) : simpleSelector;
    var symb = isClass ? meta.classes[name] : meta.elements[name];
    // when class have an -st-extends or elements is an alias we want to drill into their internal structure
    var symbType = symb ? (isClass ? symb['-st-extends'] : symb.alias) : undefined;
    if (symbType) {
        var origin_1 = resolver.resolveSymbolOrigin(symbType, meta);
        if (origin_1 &&
            origin_1._kind === 'css' &&
            origin_1.symbol._kind === 'class' &&
            origin_1.symbol.name === origin_1.meta.root) {
            // go over all internal parts and add them to the tree
            for (var key in origin_1.meta.classes) {
                if (key === origin_1.meta.root) {
                    // we will handle root in later stage
                    continue;
                }
                else {
                    elementsTree[simpleSelector][key] = createElementsTree(origin_1.meta, ".".concat(key), resolver)[".".concat(key)];
                }
            }
            // add all root parts to the tree
            var rootExtensions = createElementsTree(origin_1.meta, ".".concat(origin_1.meta.root), resolver)[".".concat(origin_1.meta.root)];
            // root parts are flatten to the root of the tree since they are the same element
            Object.assign(elementsTree[simpleSelector], rootExtensions);
        }
    }
    // find usage of native pseudo element for all tree parts
    walk(elementsTree[simpleSelector], function (_, path) {
        var selector = path.join('::');
        // create regexp that match usage of pseudo elements at the end of the selector
        var matcher = new RegExp('^' + selector.replace(/\./g, '\\.') + '::(.*)$');
        meta.ast.walkRules(function (rule) {
            rule.selectors.forEach(function (ruleSelector) {
                var match = ruleSelector.match(matcher);
                if (match) {
                    var name_1 = match[1];
                    var setPath = path.concat(name_1);
                    if (!getProp(elementsTree, setPath) && native_pseudo_elements_set_1.nativePseudoElementsSet.has(match[1])) {
                        setProp(elementsTree, setPath, {});
                    }
                }
            });
        });
    }, [simpleSelector]);
    return elementsTree;
}
exports.createElementsTree = createElementsTree;
function walk(tree, visitor, path) {
    visitor(tree, path);
    for (var key in tree) {
        walk(tree[key], visitor, path.concat(key));
    }
}
function setProp(object, keys, val) {
    if (keys.length > 1) {
        object[keys[0]] = object[keys[0]] || {};
        return setProp(object[keys[0]], keys.slice(1), val);
    }
    object[keys[0]] = val;
}
function getProp(object, keys, defaultVal) {
    object = object[keys[0]];
    if (object && keys.length > 1) {
        return getProp(object, keys.slice(1), defaultVal);
    }
    return object === undefined ? defaultVal : object;
}
//# sourceMappingURL=create-elements-tree.js.map